import { safeDeleteSheet } from "@/lib/office-helpers";

const INVENTORY_SHEET = "Inventario de alimentos";
const ORGANIC_SHEET = "Alimentos orgánicos";

const INVENTORY_ROWS: (string | number)[][] = [
  [110562, "Hix Perro cachorro/Gato cachorro", "Alimento para perro cachorro", 10, 24.99, 249.9],
  [110563, "Hix Perro cachorro/Gato cachorro", "Alimento para perro cachorro con / Carne", 7, 29.99, 209.93],
  [110564, "Hix Perro cachorro/Gato cachorro", "Alimento para gato cachorro", 10, 19.99, 199.9],
  [110565, "Hix Perro cachorro/Gato cachorro", "Alimento para gato cachorro con / Pescado", 8, 24.99, 199.92],
  [110566, "Hix Perro", "Alimento para perro", 15, 34.99, 524.85],
  [110567, "Hix Perro", "Alimento para perro con / Carne", 9, 39.99, 359.91],
  [110568, "Hix Perro", "Alimento para perro grande", 3, 37.99, 113.97],
  [110569, "Hix Perro", "Alimento para perro con limpiador de dientes", 5, 37.99, 189.95],
  [110570, "Hix Perro", "Alimento para perro de lujo", 2, 45.99, 91.98],
  [110571, "Hix Gato", "Alimento para gato", 15, 29.99, 449.85],
  [110572, "Hix Gato", "Alimento para gato con / Pescado", 10, 32.99, 329.9],
  [110573, "Hix Gato", "Alimento para gatos grandes", 3, 32.99, 98.97],
  [110574, "Hix Gato", "Alimento para gato con limpiador de dientes", 1, 31.99, 31.99],
  [110575, "Hix Gato", "Alimento para gato de lujo", 3, 36.99, 110.97],
  [80433, "Ganado", "Alimento para perro", 5, 19.99, 99.95],
  [80434, "Ganado", "Alimento para gato", 6, 19.99, 119.94],
  [80435, "Ganado", "Alimento para pollo", 3, 14.99, 44.97],
  [80436, "Ganado", "Alimento para vaca", 5, 39.99, 199.95],
  [80437, "Ganado", "Alimento para caballo", 5, 37.99, 189.95],
  [80438, "Ganado", "Alimento para ovejas", 4, 22.99, 91.96],
  [80439, "Ganado", "Alimento para cerdo", 2, 26.99, 53.98],
  [80440, "Ganado", "Alimento para llama", 5, 25.99, 129.95],
];

const ORGANIC_ROWS: (string | number)[][] = [
  [100814, "Niblets de Norberto", "Comida orgánica gourmet para Cachorros", 3, 35.99, 107.97],
  [100814, "Niblets de Norberto", "Comida orgánica gourmet para Gatitos", 3, 35.99, 107.97],
  [100814, "Niblets de Norberto", "Comida orgánica gourmet para Perro", 7, 39.99, 279.93],
  [100814, "Niblets de Norberto", "Comida orgánica gourmet para Gato", 4, 39.99, 159.96],
  [100814, "Niblets de Norberto", "Comida orgánica gourmet para Caballo", 8, 54.99, 439.92],
  [100814, "Niblets de Norberto", "Comida orgánica gourmet para Cerdo", 8, 52.99, 423.92],
  [100814, "Niblets de Norberto", "Comida orgánica gourmet para Vaca", 8, 59.99, 479.92],
];

function applyProject18PrintLayout(
  sheet: Excel.Worksheet,
  orientation?: Excel.PageOrientation,
): void {
  sheet.pageLayout.leftMargin = 0.7;
  sheet.pageLayout.rightMargin = 0.7;
  sheet.pageLayout.topMargin = 0.75;
  sheet.pageLayout.bottomMargin = 0.75;
  sheet.pageLayout.headerMargin = 0.3;
  sheet.pageLayout.footerMargin = 0.3;

  if (orientation) {
    sheet.pageLayout.orientation = orientation;
  }
}

export async function startProject18(): Promise<void> {
  await Excel.run(async (context) => {
    await safeDeleteSheet(context, INVENTORY_SHEET);
    await safeDeleteSheet(context, ORGANIC_SHEET);

    const inventory = context.workbook.worksheets.add(INVENTORY_SHEET);
    const organic = context.workbook.worksheets.add(ORGANIC_SHEET);

    inventory.getRange("A1:F1").merge();
    inventory.getRange("A1").values = [["Alimento de animales del país"]];
    inventory.getRange("A1").format.font.size = 28;
    inventory.getRange("A1").format.font.color = "#C04000";
    inventory.getRange("A1").format.font.bold = true;
    inventory.getRange("1:1").format.rowHeight = 34.5;

    const table = inventory.tables.add("A3:F3", true);
    table.name = "Tabla1";
    table.getHeaderRowRange().values = [[
      "SKU#",
      "Marca",
      "Descripción",
      "Inventario",
      "Precio",
      "Total",
    ]];
    table.rows.add(undefined, INVENTORY_ROWS);
    table.style = "TableStyleMedium7";

    inventory.getRange("E4:F25").numberFormat = Array(INVENTORY_ROWS.length).fill([
      "$#,##0.00",
      "$#,##0.00",
    ]);
    inventory.getRange("A:A").format.columnWidth = 55;
    inventory.getRange("B:B").format.columnWidth = 195;
    inventory.getRange("C:C").format.columnWidth = 280;
    inventory.getRange("D:D").format.columnWidth = 70;
    inventory.getRange("E:E").format.columnWidth = 60;
    inventory.getRange("F:F").format.columnWidth = 60;

    const cond = inventory.getRange("D4:D25").conditionalFormats.add(
      Excel.ConditionalFormatType.iconSet,
    );
    cond.iconSet.style = Excel.IconSet.threeArrows;

    inventory.getRange("B27").values = [["†"]];
    inventory.getRange("C27").values = [[
      "Alimentos orgánicos disponibles estacionalmente",
    ]];
    inventory.getRange("C27").hyperlink = {
      documentReference: `'${ORGANIC_SHEET}'!A1`,
      textToDisplay: "Alimentos orgánicos disponibles estacionalmente",
    };
    inventory.getRange("C27").format.font.underline = "Single";
    inventory.getRange("C27").format.font.color = "#E0A800";

    inventory.getRange("B30:C30").merge();
    inventory.getRange("B30").values = [["Totals"]];
    inventory.getRange("B30:C30").format.fill.color = "#C04000";
    inventory.getRange("B30:C30").format.font.color = "#FFFFFF";
    inventory.getRange("B30:C30").format.font.bold = true;

    inventory.getRange("B31:C34").values = [
      ["Hix Perro cachorro/Gato cachorro", 859.65],
      ["Hix Perro", 1280.66],
      ["Hix Gato", 1021.68],
      ["Ganado", 930.65],
    ];
    inventory.getRange("C31:C34").numberFormat = Array(4).fill(["0.00"]);
    inventory.getRange("B31:B34").format.font.bold = true;
    for (const border of ["EdgeTop", "EdgeBottom", "EdgeLeft", "EdgeRight", "InsideHorizontal", "InsideVertical"] as const) {
      inventory.getRange("B30:C34").format.borders.getItem(border).style = "Continuous";
      inventory.getRange("B30:C34").format.borders.getItem(border).color = "#000000";
    }

    const chart = inventory.charts.add(
      Excel.ChartType.pie,
      inventory.getRange("B31:C34"),
      Excel.ChartSeriesBy.columns,
    );
    chart.title.text = "Inventario total";
    chart.setPosition("H3", "M16");
    chart.style = 102;
    chart.legend.visible = false;

    organic.getRange("A1:F1").merge();
    organic.getRange("A1").values = [["Alimento de animales del país"]];
    organic.getRange("A1").format.font.size = 28;
    organic.getRange("A1").format.font.color = "#C04000";
    organic.getRange("A1").format.font.bold = true;
    organic.getRange("1:1").format.rowHeight = 34.5;
    organic.getRange("A3:F3").values = [[
      "SKU#",
      "Marca",
      "Descripción",
      "Inventario",
      "Precio",
      "Total",
    ]];
    organic.getRange("A3:F3").format.fill.color = "#C04000";
    organic.getRange("A3:F3").format.font.color = "#FFFFFF";
    organic.getRange("A3:F3").format.font.bold = true;
    organic.getRange("A4:F10").values = ORGANIC_ROWS;
    organic.getRange("E4:F10").numberFormat = Array(ORGANIC_ROWS.length).fill([
      "$#,##0.00",
      "$#,##0.00",
    ]);
    organic.getRange("A:A").format.columnWidth = 55;
    organic.getRange("B:B").format.columnWidth = 130;
    organic.getRange("C:C").format.columnWidth = 280;
    organic.getRange("D:D").format.columnWidth = 70;
    organic.getRange("E:E").format.columnWidth = 60;
    organic.getRange("F:F").format.columnWidth = 60;

    applyProject18PrintLayout(inventory, Excel.PageOrientation.portrait);
    applyProject18PrintLayout(organic);

    inventory.activate();
    inventory.getRange("A1").select();

    await context.sync();
  });
}
